/**
 * @ngdoc directive
 * @name reserveDevice
 *
 * @description
 *  reserve device salesForce iFrame and post Form template directive
 *
 * @restrict A
 * */
(function () {
  'use strict';
  angular
    .module('eclipseApp.reserveDevice')
    .directive('uteReserveDevice', _reserveDevice);

  function _reserveDevice() {
    var directive = {
      restrict: 'EA',
      scope: true,
      templateUrl: 'modules/reserveDevice/nrsform.html',
      replace: true,
      controller: 'uteReserveDeviceNRSFormCtrl',
      controllerAs: 'rd',
      bindToController: true
    };
    return directive;
  }
})();
